import type {
  TScannerCredentialFieldsQueryPayload,
  TScannerCredentialFieldsUpdatePayload,
} from '../models/types';

type TScannerCredentialFieldsTargetPayload =
  | TScannerCredentialFieldsQueryPayload
  | TScannerCredentialFieldsUpdatePayload;

export const scannerCredentialFieldsQueryKeys = {
  all: ['scannerCredentialFields'] as const,
  singleScan: () => [...scannerCredentialFieldsQueryKeys.all, 'single-scan'] as const,
  integration: (integrationId: string) =>
    [...scannerCredentialFieldsQueryKeys.all, 'integration', integrationId] as const,
};

export function getScannerCredentialFieldsQueryKey(payload: TScannerCredentialFieldsTargetPayload) {
  if (payload.mode === 'single-scan') {
    return scannerCredentialFieldsQueryKeys.singleScan();
  }

  return scannerCredentialFieldsQueryKeys.integration(payload.integrationId);
}
